import { createAsyncAction, createStandardAction } from "typesafe-actions";
import { IProfile, UserID, IProfileUpdate } from "../api/APIClient";

export const toggleUserModalOpen = createStandardAction(
  "TOGGLE_USER_MODAL_OPEN"
)();
export const showUserModal = createStandardAction("SHOW_USER_MODAL")<UserID>();

export const updateProfileProgress = createAsyncAction(
  "UPDATE_PROFILE_REQUEST",
  "UPDATE_PROFILE_SUCCESS",
  "UPDATE_PROFILE_FAILURE"
)<IProfileUpdate, IProfile, Error>();

export const fetchProfiles = createAsyncAction(
  "FETCH_PROFILES_REQUEST",
  "FETCH_PROFILES_SUCCESS",
  "FETCH_PROFILES_FAILURE"
)<void, IProfile[], Error>();



// WEBPACK FOOTER //
// ./src/actions/profileActions.ts